import { Modal, Title } from "@mantine/core";
import { PlaylistFeedbackForm, FeedbackFormData } from "./PlaylistFeedbackForm";

interface PlaylistFeedbackModalProps {
  /** Whether the modal is open */
  opened: boolean;
  /** Function to call when the modal should be closed */
  onClose: () => void;
  /** The rating that triggered this feedback modal (should be 3 or below) */
  rating: number;
  /** Playlist ID for tracking purposes */
  playlistId?: string;
  /** Modal size */
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "auto" | string | number;
  /** Whether to center the modal */
  centered?: boolean;
  /** Custom title override */
  title?: string;
  /** Callback when feedback is successfully submitted */
  onFeedbackSubmitted?: (data: FeedbackFormData) => void;
}

export function PlaylistFeedbackModal({
  opened,
  onClose,
  rating,
  playlistId,
  size = "lg",
  centered = true,
  onFeedbackSubmitted,
}: PlaylistFeedbackModalProps) {
  const modalTitle = "Help us improve!";

  const handleFeedbackSubmit = (data: FeedbackFormData) => {
    // Process the feedback using the provided handlers

    // Call the optional callback
    if (onFeedbackSubmitted) {
      onFeedbackSubmitted(data);
    }

    // Close the modal
    onClose();
  };

  const handleFeedbackCancel = () => {
    // Track cancellation

    // Close the modal
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={2}>{modalTitle}</Title>}
      size={size}
      centered={centered}
      withCloseButton={true}
    >
      <PlaylistFeedbackForm
        rating={rating}
        playlistId={playlistId}
        onSubmit={handleFeedbackSubmit}
        onCancel={handleFeedbackCancel}
      />
    </Modal>
  );
}
